module.exports = __webpack_public_path__ + "img/arty_technology.5cd463ab.svg";